
































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import { CookieStorage } from "cookie-storage";
import { ApiClient } from "@common/services/ApiClient";

export default Vue.extend({
  data() {
    return {
      valid: false,
      loading: false,
      error: "",
      ruleRequired: (value) => !!value || this.$t("REQUIRED"),
      data: {},
    };
  },
  methods: {
    async submit() {
      this.error = "";
      this.loading = true;
      try {
        const { access_token: accessToken } = await coreApiClient.callRaw("auth", "login", undefined, {
          username: this.data.loginName,
          password: this.data.password,
          deviceId: userManager.getDeviceId(),
        });
        if (accessToken) {
          userManager.setAccessToken(accessToken);
          new CookieStorage().setItem("access_token", accessToken, {
            expires: new Date(new Date().getTime() + 86400 * 1000),
          });
          ApiClient.reset();
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$router.push(this.$route.query.redirect || "/app");
        }
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
      }
    },
  },
});
